import { render, staticRenderFns } from "./ClmTypeAttachs.vue?vue&type=template&id=ed335aae&"
import script from "./ClmTypeAttachs.vue?vue&type=script&lang=js&"
export * from "./ClmTypeAttachs.vue?vue&type=script&lang=js&"
import style0 from "./ClmTypeAttachs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClmTypeAttachs.vue"
export default component.exports